import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { Reason } from '../_models/reason.model';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth';
import { environment } from 'src/environments/environment';

@Injectable()
export class ReasonService {
  private authToken;
  private company_id;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.company_id = res.companyID));
  }

  private static getReasonsListQueryString(queryParams: QueryParamsModel): string {
    const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
    let fromString = `page=${pageNumber}&size=${pageSize}&sort=${sortField},${sortOrder}`;

    if (filter.searchTerm) {
      fromString += `&search_term=${filter.searchTerm}`;
    } else {
      if (filter.reason) fromString += `&reason_has=${filter.reason}`;
    }

    return fromString;
  }

  createReason(_reason) {
    const url = `${environment.DRP_BASE}/companies/${this.company_id}/reasons`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<Reason>(url, _reason, { headers });
  }

  findReasons(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const url = `${environment.DRP_BASE}/companies/${this.company_id}/reasons`;
    const params = new HttpParams({
      fromString: ReasonService.getReasonsListQueryString(queryParams),
    });
    return this.http.get<QueryResultsModel>(url, { params });
  }

  updateReason(_reason): Observable<any> {
    const url = `${environment.DRP_BASE}/companies/${this.company_id}/reasons/${_reason.id}`;
    return this.http.put<Reason>(url, _reason);
  }

  deleteReason(reasonId: number): Observable<any> {
    const url = `${environment.DRP_BASE}/companies/${this.company_id}/reasons/${reasonId}`;
    return this.http.delete<any>(url);
  }
}
